import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomCareCompanyComponent} from './custom-care-company.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {CustomLoginFormModule} from '../../../../spartacus/features/user/account/components/custom-login-form/custom-login-form.module';
import {FormErrorsModule} from "@spartacus/storefront";
import {CustomIconsModule} from "../../../icons/custom-icons.module";
import {ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";


@NgModule({
  declarations: [CustomCareCompanyComponent],
    imports: [
        CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CaresCompanyFormComponent: {
                    component: CustomCareCompanyComponent,
                },
            },
        } as CmsConfig),
        I18nModule,
        CustomLoginFormModule,
        FormErrorsModule,
        CustomIconsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
    ]
})
export class CustomCareCompanyModule { }
